import { useLocation, useNavigate } from 'react-router-dom'
import { useEvenI18n } from '../i18n/even.js'

export function BottomNav() {
  const { pathname } = useLocation()
  const navigate     = useNavigate()
  const t            = useEvenI18n()

  const isActive = (base) => pathname === base || pathname.startsWith(base + '/')

  return (
    <nav className="bottom-nav">
      <button
        className={`bnav-btn${isActive('/groups') ? ' active' : ''}`}
        onClick={() => navigate('/groups')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
        {t.nav.groups}
      </button>
      <button
        className={`bnav-btn${isActive('/people') ? ' active' : ''}`}
        onClick={() => navigate('/people')}
      >
        {/* persona + scambio: il saldo con una singola persona, non col gruppo */}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="8" cy="7" r="3.5" />
          <path d="M2 21v-1.5A4.5 4.5 0 0 1 6.5 15h3a4.5 4.5 0 0 1 4.5 4.5V21" />
          <path d="M17 7h5m0 0-2-2m2 2-2 2" />
          <path d="M22 13h-5m0 0 2-2m-2 2 2 2" />
        </svg>
        {t.nav.people}
      </button>
      <button
        className={`bnav-btn${isActive('/activity') ? ' active' : ''}`}
        onClick={() => navigate('/activity')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
        {t.nav.activity}
      </button>
      <button
        className={`bnav-btn${isActive('/converter') ? ' active' : ''}`}
        onClick={() => navigate('/converter')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 7h13M13 3l4 4-4 4" />
          <path d="M20 17H7M11 13l-4 4 4 4" />
        </svg>
        {t.nav.converter}
      </button>
    </nav>
  )
}
